import { FunctionComponent, useEffect } from 'react';

import { useGenerateImageFromCharts } from 'PDF/hooks/useGenerateImageFromCharts';

import { LinesChart } from './LinesChart';
import { ILinesChart } from '../types';

interface ILinesChartWrapper {
  info: ILinesChart;
  aspectRatio?: number;
  updateState: (title: string, src: string) => void;
}

export const LinesChartWrapper = ({ info, aspectRatio, updateState }: ILinesChartWrapper) => {
  const [chartPortal, chartImgSrc] = useGenerateImageFromCharts(LinesChart as FunctionComponent, { info, aspectRatio });

  useEffect(() => {
    if (chartImgSrc) {
      updateState(info.title, chartImgSrc as string);
    }
  }, [chartImgSrc]);

  return <>{chartPortal}</>;
};
